// extracted by mini-css-extract-plugin
export default {"tooltip":"IR-z","arrow":"JR-z"};